export default {
  // Allgemein
  language_picker_helper: "Wähle eine Sprache",
  languages: {
    english: "Englisch",
    german: "Deutsch",
    spanish: "Spanisch",
    french: "Französisch"
  },
  languagesCodes: {
    english: "GB",
    german: "DE",
    spanish: "ES",
    french: "FR"
  },
  langcodeShort: "DE",
  langcode: "de-DE",
  messagesLanguage: "Benachrichtigungssprache",
  greeting: "Hallo",
  unexpectedError: "Ein unbekannter Fehler ist aufgetreten!",
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
  sunday: "Sonntag",
  username: "Benutzername",
  password: "Passwort",
  logout: "Ausloggen",
  since: "seit",
  clock: "Uhr",
  oClock: "Uhr",
  back: "Zurück",
  deviceConfig: "Geräte Konfiguration öffnen",
  active: "Aktiv",
  inactive: "Inaktiv",
  save: "Speichern",
  absence: "Abwesenheit",
  requestable: "Anfragbar",
  unpaidAbsence: "unbezahlte Abwesenheit",
  userIsWorkingInProject: "Der Mitarbeiter arbeitet momentan an einem Projekt",
  all: "Alle",
  delete: "Löschen",
  send: "senden",
  date: "Datum",
  search: "Suche",
  legend: "Legende",
  time: "Zeit",
  comment: "Kommentar",
  passwordNoMatch: "Passwörter stimmen nicht überein",
  passwordTooShort: "Passwort ist zu kurz",
  resetPassOnLogin: "Passwort bei Anmeldung zurücksetzen",
  cancel: "Abbrechen",
  passwordSaved: "Passwort gespeichert",
  changePasswordQuestion: "Möchten Sie das Passwort ändern",
  insertPassword: "Passwort eingeben",
  insertAdminPassword: "Admin Passwort eingeben",
  confirmPassword: "Passwort bestätigen",
  confirm: "Bestätigen",
  history: "Historie",
  workTime: "Arbeitszeit",
  pause: "Pause",
  monthlyWorkTime: "Die monatliche Arbeitszeit beträgt",
  showDeletedBookingLines: "Gelöschte Buchungen anzeigen",
  hideDeletedBookingLines: "Gelöschte Buchungen verstecken",
  addTime: "Zeit hinzufügen",
  project: "Projekt",
  add: "Hinzufügen",
  changeTime: "Zeit ändern",
  timestamp: "Zeitpunkt",
  duration: "Dauer",
  coming: "Kommen",
  going: "Gehen",
  businessTrip: "Dienstreise",
  errandStart: "Dienstgang startern",
  errandEnd: "Dienstgang beenden",
  changeLine: "Zeile ändern",
  timeOverlapse: "Die Zeit überschneidet sich mit einer anderen Buchung",
  timeToBigFor: "Die Zeit darf nicht größer als",
  be: "sein",
  editBookingLineWithoutComment: "Wollen Sie sicher eine korrigierte Buchung ohne Kommentar anlegen",
  timeNotEntered: "Zeit wurde nicht eingegeben",
  statusNotEntered: "Status wurde nicht eingegeben",
  worktimeIs: "Arbeitszeit beträgt",
  pauseTimeIs: "Pausenzeit beträgt",
  accept: "Annehmen",
  decline: "Ablehnen",
  declined: "Abgelehnt",
  reason: "Grund",
  absenceReason: "Abwesenheitgrund",
  prevDay: "Vorheriger Tag",
  nextDay: "Nächster Tag",
  prevMonth: "Vorheriger Monat",
  nextMonth: "Nächster Monat",
  successfullyTransmitted: "Erfolgreich übermittelt",
  cobiServerNotRunning: "COBI.time Server: Keine Rückmeldung",
  cobiServerUp: "Verbindung zum COBI.time Server erfolgreich wiederhergestellt",
  finished: "beendet",
  or: "oder",
  started: "gestartet",
  hours: "Stunden",
  activity: "Aktivität",
  noRight: "Benutzer hat keine Rechte",
  publicHolidays: "Feiertage",
  publicHoliday: "Feiertag",
  state: "Bundesland",
  import: "Importieren",
  changesWillBeLostMessage: "Alle nicht gespeicherten Änderungen gehen verloren",
  workDay: "Arbeitstag",
  request: "Anfordern",
  select: "Auswählen",
  month: "Monat",
  year: "Jahr",
  publicHolidaysLetter: "F",
  workDayLetter: "A",
  vacation: "Urlaub",
  changes: "Änderungen",
  added: "Hinzugefügt",
  edited: "Bearbeitet",
  deleted: "Gelöscht",
  errorByUser: "Fehler bei Benutzer",
  from: "von",
  until: "bis",
  attachments: "Anhänge",
  noBlanksError: "Keine Leerzeichen zulässig",
  location: "Standort",
  showAll: "Alle anzeigen",
  settings: "Einstellungen",
  reset: "reset",
  darkMode: "dunkle Modus",
  lightMode: "light mode",
  resetAll: "Alles zurücksetzen",
  discardSelected: "Auswahl verwerfen",
  timeOff: "Abwesenheit",
  half: "halben",
  halfDay: "halben Tag",
  fullDay: "ganzen Tag",
  startValue: "Startwert",
  close: "Schließen",
  refresh: "Aktualisieren",
  management: "Management",
  selected: "{0} ausgewählt",

  automaticCloseOpenBookingHintTitle: "Hinweis zur automatischen Ausbuchung",
  automaticCloseOpenBookingHint:
    "Ihre offene Buchung vom Vortag wurde automatisch mit der letzten <b>Buchung + 1 Minute</b> abgeschlossen, da keine Abmeldung erfolgt ist. Falls eine Korrektur erforderlich ist, können Sie:",
  automaticCloseOpenBookingHintPart1: "● Ihre Zeit <b>selbst am PC</b> korrigieren oder <br />● sich an <b>Ihren Vorgesetzten</b> wenden.",

  automaticCloseOpenBookingHelpTitle: "Automatische Ausbuchung(Terminalmodus)",
  automaticCloseOpenBookingHelp:
    "Ist diese Option aktiviert, wird ein Mitarbeiter im <b>Terminalmodus</b> nicht mehr zur Zeitkorrektur aufgefordert, wenn er sich am Vortag nicht ordnungsgemäß abgemeldet hat. " +
    "Stattdessen wird die offene Buchung automatisch mit <b>der letzten Buchungszeit + 1 Minute</b> abgeschlossen, sobald sich der Mitarbeiter am nächsten Tag erneut anmeldet. " +
    "Diese Funktion ist <b>ausschließlich im Terminalmodus</b> aktiv und dient dazu, den Anmeldevorgang zu beschleunigen und unnötige Belegung des Terminals zu vermeiden.",

  // MainMenu
  avgWorkingHours: "Durchschn. Arbeitszeit",
  avgBreakTime: "Durchschn. Pausenzeit",
  overtime: "Überstunden",
  nonBillableTime: "Nicht verrechenbare Zeit",
  logoutWarning: "Wollen Sie sich wirklich abmelden?",

  // Auth
  userPin: "Benutzerpin",
  resetPass: "Passwort zurücksetzen",
  RFIDScannerText: "Scan ist gestartet",
  PleasePresentRFIDChip: "Bitte RFID-Chip vorlegen",
  RFIDNumberNotFound: "RFID-Nummer nicht gefunden!",
  RFIDRegistration: "RFID-Chip Anmeldung",
  RFIDReset: "RFID-Chip zurücksetzen",

  // FaceLogin.vue
  faceFound: "Gesicht erkannt! Versuche Login..",
  faceLoginHelp: "Bitte still halten während des Gesichtserkennungsprozesses",
  pleaseEnterPin: "Bitte PIN zum Login eingeben!",
  enterPin: "PIN eingeben",
  employeeNotRecognized: "Mitarbeiter nicht erkannt!",
  faceLoginRestarting: "Gesichtserkennung wird neugestartet",

  // Menu.vue
  timekeeping: "Zeiterfassung",
  manualTimekeeping: "Manuelle Zeiterfassung",
  administration: "Verwaltung",
  presencelist: "Anwesenheitsliste",
  mainmenu: "Hauptmenü",

  // Usermenu.vue
  notifications: "Benachrichtigungen",
  noNotification: "Keine Benachrichtigung erhalten",
  newNotification: "neue Benachrichtigungen",
  openNotification: "Benachrichtigungen öffnen",
  unread: "Ungelesen",
  userFunctions: "Benutzerfunktionen",
  showHistory: "Zeige Historie",
  absenceRequest: "Abwesenheitsantrag",
  timeCorrectionRequest: "Zeitkorrekturantrag",
  noTimeBookedForThisDate: "Keine Buchungen für diesen Tag gefunden",
  undoClue: "Möchten Sie wirklich die Änderungen zurücksetzen?",
  deleteTimeLineClue: "Möchten Sie wirklich die Zeile löschen?",
  showDetails: "Details anzeigen",
  changePic: "Bild ändern",
  noPictureUploaded: "Es wurde kein Bild hochgeladen",
  profilePictureNotSaved: "Das Profilbild konnte nicht hochgeladen werden. (Falsches Format oder zu groß - Maximal 2mb)",
  messages: "Nachrichten",
  subject: "Betreff",
  chooseMessage: "Bitte wählen Sie eine Nachricht aus",
  deleteMessagesQuestion: "Möchten Sie wirklich diese Benachrichtigungen entfernen",
  markAllAsReadQuestion: "Möchten Sie wirklich alle Benachrichtigungen als gelesen markieren",
  userInfo: "Benutzerinformationen",
  timeCorrection: "Zeitkorrektur",
  timeCorrectionWasSuccessfulApproved: "Zeitkorrekturantrag wurde erfolgreich genehmigt",
  timeCorrectionRequestNotFound: "Zeitkorrekturantrag wurde nicht gefunden",

  // Status
  absent: "Abwesend",
  present: "Anwesend",
  inproject: "Im Projekt",
  inServiceCall: "Im Serviceabruf",
  inpause: "In der Pause",
  break: "Pause",

  // Administration.vue
  userAdministration: "Benutzerverwaltung",
  generalSettings: "Allgemeine Einstellungen",
  changeLogo: "Logo ändern",
  resetLogo: "Logo zurücksetzen",
  upload: "Hochladen",
  absenceReasons: "Abwesenheitsgründe",
  manage: "Verwalten",
  factorAuth: "2 Faktor Authentifizierung (Gesicht & Pin)",
  absenceAdministration: "Abwesenheitsverwaltung",
  importSapUser: "SAP Benutzer importieren",
  importUser: "Benutzer importieren",
  editUser: "Benutzer bearbeiten",
  projectAdministration: "Projektverwaltung",
  sapUserCodeIsMissingError: "Beim Benutzer {0} fehlt der SAP Benutzercode!",
  sapUserExtIdError: "Externe Mitarbeiternummer bei Benutzer {0} ist zu lang!",
  userWithSameCodeError: "Benutzer mit dem gleichen SAP Benutzercode ist schon vorhanden",
  settingSuccessfulSaved: "Einstellung wurde erfolgreich gespeichert!",
  TimeAccountRecalculation: "Zeitkonten neu berechnen",
  startTimeAccountRecalculation: "Berechnung starten",
  timeAccountAlreadyRecalculateError: "Zeitkonten werden gerade neu berechnet",
  publicHolidaysAdministration: "Feiertage Verwaltung",
  projectManagement: "Projektstufen",
  serviceCalls: "Serviceabrufe",
  permissionsAndAssignments: "Rechte und Zuweisungen",
  searchForBusinessPartner: "Suche nach Geschäftspartner Namen oder Code",
  editProjectStagesFor: "Projektstufen bearbeiten für",
  editServiceCallsFor: "Service Abrufe bearbeiten für",

  //Settings.vue
  stageProjectsAllowed: "Buchen auf Projekte aus Projektmanagement aktivieren?",
  settingsWasSaved: "Einstellungen wurden gespeichert",
  stageProjectsWithoutPermissions: "Berechtigungssystem für Projekte aus dem Projektmanagement aktivieren?",
  showFinanceProjectByProjectManagement: "Bei den Projekten aus dem Projektmanagement die Finanzprojekt Name anzeigen?",
  serviceCallsAllowed: "Buchen auf Serviceabrufe aktivieren?",
  serviceCallsWithoutPermissions: "Berechtigungssystem für Serviceabrufe aktivieren?",
  showAbsenceApprovalsInPresentList: "Abwesenheitsanfragen bei der Anwesenheitsliste anzeigen",
  financeProjectsAllowed: "Buchen auf Finanzprojekte aktivieren?",
  colorCode: "Farbcode",
  icon: "Symbol",
  allowProjectComment: "Projekt Kommentaren zulassen",
  showCostCentre: "Kostenstelle anzeigen",
  showNewTimeCorrection: "Neue Zeitkorrektur anzeigen",
  hideCommentByTimeCorrection: "Kommentarfeld bei Zeitkorrektur ausblenden",
  defaultState: "Standardeinstellung für Bundesland",
  showBusinessTripByTimeKeeping: "Dienstreisenbutton beim Zeiterfassung anzeigen",
  showBusinessTripByTimeKeepingOnlyIfItsApproved: "Dienstreisenbutton beim Zeiterfassung anzeigen, wenn eine genehmigte Dientsreise für Tag vorliegt",
  startRecalculationRequest: "Möchten Sie wirklich Zeitkonten Neuberechnung starten?  Dies kann eine Weile dauern!",
  selectRecalculationDate: "Wählen Sie bitte Datum aus. Ab dies werden alle Zeitkonten neuberechnet",
  resetAdminPassword: "Admin Passwort zurücksetzen",
  allowUserCloseOpenBooking: "Benutzereinstellungen für Korrekturbuchungen: Ja = Sofort speichern oder Nein = Zeitkorrekturantrag wird erstellt",
  requireLocation: "Zwingende Standortauswahl",
  automaticLocationByRFID: "Automatische Standortbestimmung per RFID",
  absenceForSickKPI: "Abwesenheitstyp für Krankheitsquote-KPI",
  chooseLocation: "Bitte Standort auswählen",
  settingsTitle: "Einstellungen",
  settingsTabGeneral: "Allgemein",
  settingsTabSecurity: "Sicherheit",
  settingsTabTimeManagement: "Zeitverwaltung",
  settingsTabProjects: "Projekte",
  settingsTabServiceCalls: "Serviceabrufe",
  settingsTabBusinessTrips: "Dienstreisen",
  settingsTabCalculation: "Berechnung",
  timeAccountsWarningGeneral:
    "Achtung: Startet eine systemweite Neuberechnung aller Zeitkonten. Der Vorgang kann länger dauern und die Systemleistung beeinträchtigen. Möchten Sie den Vorgang fortsetzen?",
  startRecalculationRequest: "Zeitkonten-Neuberechnung starten?",
  timeAccountsWarningText:
    "Achtung! Diese Aktion startet eine vollständige Neuberechnung aller Zeitkonten im System. Der Prozess kann lange dauern und die Oberfläche vorübergehend verlangsamen.",
  automaticCloseOpenBooking: "Automatische Ausbuchung bei fehlender Abmeldung (Terminalmodus)",
  //UserAdministration
  userHasNoTeam: "Benutzer hat kein SAP Team",
  userInSAPNotFound: "Benutzer in SAP nicht gefunden",
  employeeIsInactiveInSAP: "Benutzer ist inaktiv SAP",
  userHasActiveTimeAccount: "Benuter kann nicht gelöscht werden, solange ein Zeitkonto aktiv ist",
  userHasActiveHolidayAccount: "Benuter kann nicht gelöscht werden, solange ein Urlaubskonto aktiv ist",
  userDeleteMessage: "Möchten Sie wirklich folgenden Benutzer deaktivieren:",
  holidayDeleteMessage: "Möchten Sie wirklich folgenden Urlaub entfernen:",
  activateUser: "Benutzer aktivieren",
  deactivateUser: "Benutzer deaktivieren",
  deleteUser: "Benutzer löschen",
  edit: "Bearbeiten",
  resetPassword: "Passwort zurücksetzen",
  showInactiveUser: "Deaktivierte Benutzer anzeigen",
  hideInactiveUser: "Deaktivierte Benutzer ausblenden",
  usersSuccessfulDelete: "Benutzer wurden erfolgreich deaktiviert",
  userCodeLengthError: "Benutzercode darf nicht länger als 20 Zeichen sein",
  resetRFIDMessage: "Möchten Sie wirklich die RFID Nummer zurücksetzen?",
  rfidSuccessfullyReset: "RFID Nummer wurde erfolgreich zurückgesetzt",
  rfidCodeAllreadyExists: "RFID Nummer existiert bereits",
  rfidSuccessfullyAdded: "RFID Nummer wurde erfolgreich hinzugefügt",
  team: "Team",

  //EditUser
  validFrom: "Gültig ab:",
  validUntil: "Gültig bis:",
  timeModel: "Zeitmodell",
  autoModel: "Automatisches Zeitmodell",
  startTimeHours: "Startwert Stunden",
  dateNoSelectedError: "Datum wurde nicht ausgewählt",
  vacationDays: "Urlaubstage",

  notEnoughHolidaysLeft: "Benutzer hat nicht genug Urlaubstage",
  groupSaveSuccessful: "Gruppen für den Benutzer {0} wurden erfolgreich hinterlegt!",
  editHolidayAccount: "Urlaubskonto bearbeiten",
  closingTimeAccountInPastWarning:
    "Achtung! Sie möchten ein Zeitkonto in der Vergangenheit schließen. Dadurch werden die verlieren die Buchungszeilen ihre Zuordnung zum Zeitkonto. Die Zuordnung können Sie mit der Erstellung eines neuem Zeitkonto wiederherstellen.",
  timeAccountForDateAlreadyExist: "Für das ausgewählte Datum liegt bereits ein Zeikonto vor",
  restHolidaysInfo: "Resturlaub ({0} Starturlaubstage vom {1} + {2} Resturlaub vom letzen Jahr - {3} Urlaubstage genommen): {4}",

  // UserGroups
  user: "Benutzer",
  bookTimes: "Zeiten Buchen",
  projectTime: "Projektzeiten",
  projectUser: "Projekt benutzer",
  userManager: "Verwaltung",
  manualTimekeeping: "Manuelle Zeiterfassung",
  presentListUser: "Anwesenheitsliste (Team)",
  presentListChef: "Anwesenheitsliste (Alle)",
  timeCorrection: "Zeiten korrigieren",
  reviewWorkTime: "Zeiten einsehen",
  reviewWorkTimeTeam: "Zeiten einsehen (Team)",
  projectAndPauseTimeManipulation: "Projekt- und Pausenzeiten korrigieren",
  canChangeBusinessTripTime: "Dientsreise nachbuchen",
  userRights: "Benutzerrechte",
  canAccessManagement: "Management",
  canAccessAbsenceOverview: "Abwesenheitsübersicht",
  canAccessAbsenceOverviewTeam: "Abwesenheitsübersicht (Team)",
  canAccessGeneralReporting: "Berichtswesen",
  canAccessGeneralReportingTeam: "Berichtswesen (Team)",
  userRightInfo: "Der Benutzer kann auf die Zeiterfassung zugreifen und Arbeitszeit buchen.",
  projectUserRightInfo: "Der Benutzer kann Projektzeiten buchen.",
  projectManagerRightInfo: "Der Benutzer kann auf die manuelle Zeiterfassung zugreifen.",
  userManagerRightInfo: "Der Benutzer hat Zugriff auf die Benutzerverwaltung und die Projektverwaltung/Servicecalls-Verwaltung.",
  presencelistRightInfo: "Der Benutzer kann auf die Anwesenheitsliste zugreifen und anwesende Mitarbeiter aus der eigenen Abteilung sehen.",
  cheifPresencelistRightInfo: "Der Benutzer kann auf die Anwesenheitsliste zugreifen und alle anwesenden Mitarbeiter sehen.",
  timesCorrectionRightInfo: "Der Benutzer kann die Arbeitszeit korrigieren.",
  seeTimesRightInfo: "Der Benutzer hat das Recht die Arbeitszeit von anderen Mitarbeitern einzusehen.",
  seeTimesRightInfoTeam: "Der Benutzer hat das Recht die Arbeitszeit von Teammitgliedern einzusehen.",
  pauseAndProjectTimeCorrectionRight: "Der Benutzer kann eigene Projekt- und Pausenzeiten korrigieren.",
  canChangeBusinessTripTimeInfo: "Der Benutzer kann Dientsreisen nachbuchen",
  canAccessManagementInfo: "Der Benutzer kann auf Management zugreifen",
  canAccessAbsenceOverviewInfo: "Der Benutzer kann auf Abwesenheitsüberischt zugreifen",
  canAccessAbsenceOverviewTeamInfo: "Der Benutzer kann auf Abwesenheitsüberischt zugreifen (Team)",
  canAccessGeneralReportingInfo: "Der Benutzer kann auf Berichtswesen zugreifen",
  canAccessGeneralReportingTeamInfo: "Der Benutzer kann auf Berichtswesen zugreifen (Team)",

  // Public Holidays
  sameDateForHolidaysError: "Für das ausgewählte Datum wurde bereits eine Abwesenheit angelegt",
  addNewHoliday: "Neues Feiertag anlegen",
  deleteHolidayMessage: "Möchten Sie wirklich folgenden Feiertag entfernen?",
  importHolidays: "Feiertage importieren",
  editPublicHolidays: "Feiertage bearbeiten",
  holidaySuccessfulDeletedMessage: "Feiertag wurde erfolgreich gelöscht",
  enterHolidayName: "Name eingeben",
  sameHolidayDateError: "Für {0} wurde schon eine Abwesenheit eingelegt",
  holidaysWarning:
    "Achtung! Wenn Sie Feiertage hier hinzufügen oder entfernen werden alle Zeitkonten korrigiert! Dies kann sehr lange dauern! Führen Sie diesen Prozess nur durch, wenn keine Benutzer angemeldet sind! Sie können auf dieser Seite prüfen wann der Prozess abgeschlossen ist.",
  saveHolidayMessage: "Möchten Sie diese Änderungen speichern?",
  takeOverHolidayToNextYear: "Ins nächste Jahr übernehmen",
  timeAccountsRecalculateAlert: "Zeitkonten werden neu berechnet. Bitte warten sie!",
  holidaysBookingProcess: "Speicherung ist nicht möglich! Zeitkonten werden gerade neu berechnet",
  holidaysNameLengthError: "Feiertagsname darf nicht größer als 100 Zeichen sein",

  // ManualTimekeeping.vue
  monthlyHistory: "Monatsübersicht",
  chooseProject: "Projekt auswählen",
  chooseActivity: "Aktivität auswählen",
  chooseFinancialProject: "Finanzprojekt auswählen",
  chooseCustomer: "Geschäftspartner auswählen",
  chooseServiceCall: "Serviceabruf auswählen",
  recordTime: "Zeit nacherfassen",
  chooseProjectError: "Bitte Projekt auswählen",
  chooseStageError: "Bitte Serviceabruf auswählen",
  bookingError: "Buchungshinweis: Nach der letzten Buchung ist mehr als ein Tag vergangen. Bitte geben Sie den korrekten Zeitpunkt an.",
  WorkAlreadyStartedError: "Arbeitstag wurde schon gestartet",
  WorkWasNotStartedError: "Arbeitstag muss erst gestartet werden",
  PauseAlreadyStartedError: "Pause wurde schon gestartet",
  PauseWasNotStartedError: "Pause wurde noch nicht gestartet",
  ProjectAlreadyStartedError: "Projekt wurde schon gestartet",
  ProjectWasNotStartedError: "Projekt wurde noch nicht gestartet",
  financeProjects: "Finanzprojekte",
  selectTime: "Wähle Uhrzeit",
  resetInputs: "Eingaben zurücksetzen",

  //BelatedStatus
  commentIsEmpty: "Kommentar fehlt!",
  correctBooking: "Zeile nacherfassen",
  deleteBookingLineWarning: "Möchten Sie wirklich die Buchungszeile löschen?",

  // Presencelist.vue
  attendancestatus: "Anwesenheitsstatus",
  presentInfoText: "Ein grünes Männchen bzw. eine grün eingefärbte Karte zeigt an, dass der Mitarbeiter auf der Arbeit ist",
  inPauseInfoText: "Ein gelbes Kaffeezeichen zeigt an, dass der Mitarbeiter sich in der Pause befindet",
  absentInfoText: "Ein rotes Männchen bzw. eine rot eingefärbte Karte zeigt an, dass der Mitarbeiter nicht auf der Arbeit ist",
  showLegend: "Zeige Legende",
  timeDot: "Zeitpunkt",
  showOnlyPresentEmployee: "Nur anwesende Mitarbeiter anzeigen",
  searchHere: "Suche hier eingeben",
  switchToTableMode: "Zu Tabellen Ansicht wechseln",
  switchToCardMode: "Zur Tableau Ansicht wechseln",
  employeeInProject: "Der Mitarbeiter befindet sich im Projekt",
  presentOnly: "Nur Anwesende",
  searchUser: "Benutzer suchen",

  // MobileQuickAccess
  quickAccess: "Schnellzugriff",
  savePageOrder: "Ihre neue Anordnung wird gespeichert...",
  reOrderEnabled: "Sie können nun die Anordnung ändern.",

  // MobileTimeReport
  vacationUsed: "Genutzt",
  vacationUnconfirmed: "unbestätigt",
  vacationOpen: "Verfügbar",

  // MobilePresenceList
  showFilterOptions: "Zeige Filteroptionen",
  hideFilterOptions: "Verstecke Filteroptionen",

  editHistory: "Historie bearbeiten",
  showComments: "Kommentare anzeigen",
  absenceErrorByBookingLinesCorrection: "Zeitkorrektur ist nicht möglich, es gibt eine Abwesenheit für das Datum: {0}",
  sameTimeError: "Seit der letzten Buchung ist weniger als eine Minute vergangen",
  addNewBookingLine: "Neue Zeile hinzufügen",
  presencelistInfoIsDeprecated: "Anwesenheitsinformationen sind nicht mehr aktuell",
  noTimeAccountLineForDay: "Für dieses Tag ist kein Zeitkonto angelegt",
  noRightForStartAndEndTimeCorrection: "Benutzer hat keine Rechte, um Start- und Endzeit zu korrigieren",
  noRightForPauseTimeCorrection: "Benutzer hat keine Rechte um Pausenzeiten zu korrigieren",
  noRightForProjectTimeCorrection: "Benutzer hat keine Rechte Projektzeiten zu korrigieren",

  //EmployeeInformation
  pauseTimeDebit: "Pausenzeit offen",

  // UserSettings.vue
  enableAbsenceEmailNotifications: "E-Mail Benachrichtigungen erhalten, wenn ein Team-Mitglied eine Abwesenheit beantragt",

  // Simpleclient.vue
  employee: "Mitarbeiter",
  employees: "Mitarbeiter",
  startTime: "Startzeit",
  endTime: "Endzeit",
  pauseStart: "Pause Start",
  pauseEnd: "Pause Ende",
  projectStart: "Projekt Start",
  projectEnd: "Projekt Ende",
  activityStart: "Aktivität Start",
  activityEnd: "Aktivität Ende",
  startBusinessTrip: "Dienstreise start",
  endBusinessTrip: "Dienstreise ende",
  activityType: "Aktivitätstyp",
  financeProject: "Finanzprojekt",
  serviceCallBusinessPartner: "Serviceabruf GP",
  serviceCall: "Serviceabruf",
  sumWorkTime: "Summe der Arbeitszeit",
  sumPause: "Summe der Pause",
  serviceCallCustomer: "Geschäftspartner",
  costCentre: "Kostenstelle",
  postWorktime: "Arbeitszeit buchen",
  dateInFuture: "Datum liegt in der Zukunft",
  dateMissing: "Datum fehlt",
  startTimeMissing: "Startzeit fehlt",
  endTimeMissing: "Endzeit fehlt",
  endTimeBeforeStart: "Endzeit muss nach Startzeit sein",
  pauseEndBeforeStart: "Pause Endzeit muss nach Pause Startzeit sein",
  pauseStartMissing: "Pause Startzeit fehlt",
  pauseEndMissing: "Pause Endzeit fehlt",
  pauseStartAndEndBeforeStart: "Pause Start und Endzeit muss nach Startzeit sein",
  pauseStartAndEndAfterEnd: "Pause Start und Endzeit muss vor Endzeit sein",
  worktimeAdded: "Arbeitszeit hinzugefügt",
  simpleClientErrorAbsences: "Fortfahren nicht möglich; Für dieses Datum wurde schon eine Abwesenheit angelegt",
  timePeriodsOverlapError: "Fehler: Die Buchungszeit überschneidet sich mit einer anderen Buchung",
  pausesOverlapError: "Pausenzeiten überschneiden sich",
  effectiveTimeError: "Nicht berechenbare Zeit darf nicht die Arbeitszeit überschreiten",
  notTimeAccountForUserError: "Für diesen Benutzer wurde keine Zeitmodell angelegt",
  dateOutOfTimeAccountRange: "Das Datum liegt außerhalb des gültigen Bereichs des Zeitkontos",
  ProjectStageNotSelected: "Projektstufe wurde nicht ausgewählt!",
  stageIsRequired: "Projektstufe fehlt!",
  serviceCallIsRequired: "ServiceCall fehlt!",
  activityIsRequired: "Aktivitätstyp fehlt!",

  // Start.vue
  configure: "Konfigurieren",
  deviceMode: "Geräte Modus",
  terminalMode: "Terminal Modus",

  // UserMessageDialog.vue
  receivedOn: "Erhalten am",
  readUnread: "Gelesen / Ungelesen markieren",
  unread: "Ungelesen",
  mailUpdated: "Benachrichtigung bearbeitet",

  // AbsenceDialog.vue
  sendAbsence: "Abwesenheit senden",
  requestAbsence: "Abwesenheit anfragen",
  chooseAbsenceRange: "Bitte wählen Sie einen Abwesenheitszeitraum aus",
  absenceRequestSuccess: "Abwesenheit erfolgreich angefragt",
  timeRequestSuccess: "Zeitkorrektur erfolgreich angefragt",
  wrongFileFormat: "Falsches dateiformat",
  userHaveNoManagerOrRepresentative: "Beim Benutzer ist keine Manager oder Vertreter hinterlegt",

  // AbsenceCalendar.vue
  absenceType: "Abwesenheitstypen",
  colorLegend: "Farblegende",
  vacationRequestsConfirmed: "Noch nicht bestätigte Urlaubsanträge",
  absenceOverview: "Abwesenheitsübersicht",
  showColorLegend: "Farblegende einblenden",
  absenceNeedToConfirm: "Abwesenheit muss noch bestätigt werden",
  hideColorLegend: "Farblegende ausblenden",
  normalWorkDay: "Normaler Arbeitstag",
  closedTimeaccountWorkDay: "Geschlossenes Zeitkonto",
  showWorkTime: "Arbeitszeit einblenden",
  acceptAbsenceWarning: "Möchten Sie den Abwesenheitsantrag annehmen",
  declineAbsenceWarning: "Möchten Sie den Abwesenheitsantrag ablehnen",
  absenceFromAccept: "Möchten Sie wirklich die Abwesenheit vom ",
  absenceFromDecline: "Möchten Sie wirklich die Abwesenheit vom ",
  fromTheEmployee: "von dem Mitarbeiter",
  savingAbsences: "Speichere Abwesenheitsgründe in Datenbank",
  absencesSaved: "Abwesenheitsgründe erfolgreich geupdatet",
  getAbsences: "Hole Abwesenheitsgründe aus SAP",
  saveAbsence: "Abwesenheiten speichern",
  absenceOverlapError: "Abwesenheiten überschneiden sich!",
  notEnoughVacationDays: "Mitarbeiter hat nicht genug Urlaubstage",
  NotEnoughVacationDaysForUser: "{0} hat nicht genug Urlaubstage",

  //AbsenceOverview
  remainingHoliday: "Resturlaub",
  changesOverview: "Änderungsübersicht",
  addedAbsences: "Hinzugefügte Abwesenheiten",
  deletedAbsences: "Gelöschte Abwesenheiten",
  approvedAbsences: "Angenommene Abwesenheiten",
  declinedAbsences: "Abgelehnte Abwesenheiten",
  changedAbsences: "Geänderte Abwesenheiten",
  selectedDays: "Ausgewählte Tagen",
  absencesForApproval: "Abwesenheiten zur Genehmigung",
  absenceAprrovalReasonLengthError: "Grund darf nicht länger als 100 Zeichen sein",
  chooseAbsencetype: "Abwesenheit auswählen",
  absenceIsPast: "Abwesenheitsänderung für {0} ist nicht möglich. Die Änderung liegt weit in der Vergangenheit",
  userHasNoTimeAccountLineForDay: "Bei Benutzer {0} ist keine Zeitkonto für ausgewählte Datum {1} angelegt",
  shiftSelectHint: "Mit Umschalt + Linksklick einen Datumsbereich auswählen",

  // About.vue
  licenseValidUntil: "Lizenz gültig bis",
  noExpiryDate: "Kein Ablaufdatum",

  // History.vue
  hideDeletedBookings: "Gelöschte Buchungen verstecken",
  showDeletedBookings: "Gelöschte Buchungen anzeigen",
  statusWorkStart: "Arbeit begonnen",
  statusWorkEnd: "Arbeit beendet",
  statusPauseStart: "Pause gestartet",
  statusPauseEnd: "Pause beendet",
  usergroups: "Benutzergruppen",
  userRights: "Benutzerrechte",
  getSAPUsers: "Hole Mitarbeiter aus SAP Datenbank",
  importSAPUsers: "Importiere SAP Mitarbeiter",
  startPassword: "Bitte Start Passwort angeben",
  noUserSelected: "Kein Benutzer ausgewählt",
  userSuccessfullyCreated: "Benutzer wurden erfolgreich erstellt",
  sapExternalUser: "SAP Externe Mitarbeiter Nr",
  sapUserCode: "SAP Benutzercode",
  startPass: "Start Passwort:",
  sapImport: "Import Mitarbeiter",
  name: "Name",
  settingsSaved: "Einstellung wurde erfolgreich gespeichert",
  chooseSettings: "Bitte alle Einstellungen belegen",
  timeErrorLastBookingLine: "Zeitfehler: Seit der letzten Buchung ist weniger als eine Minute vergangen. Möchten Sie die Anfangsbuchung löschen?",
  deleteBookingLineQuestion: "Möchten Sie die letzte Zeile löschen",
  startPause: "Erfolgreich die Pause angetreten",
  endPause: "Erfolgreich die Pause beendet",
  endPauseTime: "Die Pausenzeit beträgt: {0}",
  startProject: "Erfolgreich das Projekt: {0} gestartet",
  endProject: "Erfolgreich das Projekt beendet",
  startWork: "Erfolgreich zur Arbeit angetreten",
  endWork: "Erfolgreich die Arbeit beendet! Die gearbeitete Zeit beträgt: {0}",
  newProjectLogic: "Stufenprojekte",
  endWorkWithoutTime: "Erfolgreich die Arbeit beendet!",
  chooseStage: "Projektstufe auswählen",
  chooseActivity: "Aktivität auswählen",
  stage: "Stufe",
  editWorkTimeAccount: "Arbeitszeitkonto bearbeiten",
  worktimeAccounts: "Arbeitszeitkonten",
  projects: "Projekte",
  projectPermissions: "Projektstufen Berechtigungen",
  dataSendSuccessfully: "Daten erfolgreich gesendet",
  timeModelDeleted: "Tageszeitmodell erfolgreich gelöscht",
  activeWeekModelError: "Löschen/Ändern nicht möglich! Es gibt ein aktives Wochenmodell zu diesem Tagesmodell!",
  activeTimeAccountError: "Löschen/Ändern nicht möglich! Es gibt ein aktives Zeitkonto mit diesem Wochenmodell",
  weekModelDeleted: "Wochenzeitmodell erfolgreich gelöscht",
  weekModelWithoutNameNotAllowed: "Wochenzeitmodell ohne Bezeichnung nicht erlaubt",
  timeAccountIs: "Zeitkontosaldo beträgt",
  noTimeAccountSet: "Kein Zeitkonto hinterlegt",
  timeAccountNotAccurate: "Zeitkonto Berechnung erfolgt am nächsten Tag",
  deleteTimeAccount:
    "Möchten Sie wirklich dieses Zeitkonto deaktivieren? Das Konto wird mit den aktuellen Zeiten geschlossen. Offene Buchungen werden nicht beachtet!",
  closeTimeAccount: "Zeitkonto schließen",
  absenceForDayExists: "Für diesen Tag liegt eine Abwesenheit vor",
  workTimeHover: "Arbeitszeit",
  pauseTimeHover: "Pausenzeit",
  projectTimeHover: "Projektzeit",
  bookedSumIs: "Heutige Arbeitsstunden",
  bookedSumDebit: "Sollstunden",
  difference: "Differenz",
  showOvertimeDetails: "Details anzeigen",
  hideOvertimeDetails: "Details ausblenden",
  projectStarted: "Projekt {0} gestartet",
  serviceCallStarted: "Serviceabruf {0} gestartet",
  serviceCallFinished: "Serviceabruf {0} beendet",
  costCenterStarted: "Aktivität begonnen (Kostenstelle {0})",
  costCenterFinished: "Aktivität beendet (Kostenstelle {0})",
  commentLengthError: "Kommentar darf nicht größer als 400 Zeichen sein",
  saveChangeRequest: "Möchten Sie die Änderungen wirklich speichern?",
  noProjectSelected: "Noch kein Projekt ausgewählt!",
  noTimeAccountForDay: "Für diesen Tag liegt kein Zeitkonto vor",
  timeSheetCannotBeEdited: "Die Arbeitszeit kann für diesen Tag nicht abgeändert werden, da diese Zeitbuchung bereits in SAP verrechnet wurde.",
  comments: "Kommentare",
  editedBy: "Bearbeitet von",
  before: "Vorher",
  after: "Nachher",
  on: "am",
  at: "um",
  selectComment: "Kommentar auswählen",
  autoModelTip: "Automatische Buchung",
  closedTimeaccount: "Geschlossenes Zeitkonto",
  onSwitch: "an",
  offSwitch: "aus",
  yes: "ja",
  no: "nein",
  timeWasSuccessfullyCorrected: "Zeit wurde erfolgreich  korrigiert",
  timeAccountCorrection: "Arbeitszeitkonto Korrektur",
  timeAccountCorrectionsForDay: "Saldo Korrektur",
  timeAccountCorrectionSuccess: "Saldo wurde erfolgreich korrigiert",
  editTimeAccountDebit: "Saldo bearbeiten",
  editor: "Bearbeiter",
  correctionValue: "Korrekturwert",
  sum: "Summe",

  // Models
  excludePeriods: "Zeiträume ausschließen",
  deleteWeekModelMessage: "Möchten Sie wirklich das Wochenmodell {0} löschen?",
  everyWeek: "jede Woche",
  everySecondWeek: "jede zweite Woche",
  everyThirdWeek: "jede dritte Woche",
  monthly: "monatliche",
  editAutoWeeklyModel: "Automatischer Modell bearbeiten",
  nextAutoDayDate: "nächste Buchung Datum",
  firstBookingDate: "Erste Buchungs Datum",
  autoModelNextDateError: "Nächste Buchung Datum für {0} ist nicht gültig",
  autoModelChangeHint: "Änderung ist nicht möglich, da dieses Model schon einem Benutzer zugewiesen wurde. Bitte erstellen sie eine neue Model",
  autoModelChangeWarning: "Sobald ein automatisches Modell einem Benutzer zugewiesen wurde, kann man es nicht mehr ändern. Möchten Sie fortfahren?",
  fixedBreakTimes: "Feste Pausenzeiten",
  totalBreakTime: "Gesamtpausenzeit",
  infoForUser: "(Information für den Benutzer)",
  weekModelSuccessfullyDeactivated: "Wochenzeitmodell wurde erfolgreich deaktiviert",
  deactivateWeekModelMessage: "Möchten Sie wirklich Wochenzeitmodell deaktivieren?",
  showInactiveWeekModels: "Deaktvierte Wochenzeitmodellen anzeigen",
  hideInactiveWeekModels: "Deaktvierte Wochenzeitmodellen ausblenden",
  deductTimeFrom: "Zeit abziehen ab",

  //UserProjectPermissions.vue
  projectPerms: "Projektstufen Berechtigungen und Zuweisungen",
  selectUserHint: "Benutzer auswählen",
  selectDepartmentHint: "Abteilung auswählen",
  selectUsersHint: "Berechtigungen auf folgende Benutzer übertragen:",
  mirroringSubProject: "Teilprojektberechtigungen auf ausgewählte Benutzer übertragen",
  mirroringProject: "Projektberechtigungen auf ausgewählte Benutzer übertragen (Nur die Stufenberechtigungen werden übertragen)",
  mirroringActivity: "Aktivitätenberechtigungen auf ausgewählte Benutzer übertragen",
  mirroringActive: "Berechtigungen auf andere Benutzer übertragen",
  mirroringAll: "Alle",
  mirroringAllSelected: "Nur ausgewählte",
  mirroringOnlySelectedProject: "Nur ausgewähltes Projekt",
  mirroringOnlySelectedStage: "Nur ausgewählte Stufe",
  mirroringOnlySelectedActivities: "Nur ausgewählte Aktivitäten",
  mirroringStage: "Stufenberechtigungen auf andere Benutzer übertragen",
  mirroringAllStages: "Alle",
  mirroringAllActivities: "Alle",
  chooseMirroringType: "Bitte auswählen welche Berechtigungen übertragen werden sollen:",
  userProjectPermissionSearchState: "Suche nach Status des Projekts",
  userProjectPermissionSearchCode: "Suche nach Geschäftspartner Code",
  userProjectPermissionSearchName: "Suche nach Geschäftspartner Name",
  searchCheckbox: "Wollen Sie nach Projekten Suchen?",
  noProjects: "Keine Projekte vorhanden",
  searchDescriptionProject: "Suche nach Projekten:",
  businessPartnerCode: "Geschäftspartner Code:",
  businessPartnerName: "Geschäftspartner Name:",
  businessPartnerEmailAddress: "Geschäftspartner E-Mail Addresse:",
  permissionOnOff: "Berechtigung Aus/Ein",
  save: "Speichern",
  errorOnlyNumbers:
    "In den Feldern 'geplante Kosten' und 'geplante Stunden' sind nur numerische Werte erlaubt. Außerdem darf der Wert maximal 10 Zeichen haben. Es dürfen keine Sonderzeichen oder Buchstaben darin vorkommen",
  stateStarted: "Gestartet",
  stateStopped: "Gestoppt",
  statePaused: "Angehalten",
  stateCanceled: "Abgebrochen/Storniert",
  stateFinished: "Fertig",
  plannedCosts: "Geplante Kosten in € pro Stunde",
  plannedTime: "Geplante Zeit in Stunden",
  successfullySetProjectPermissions: "Projektberechtigungen wurden erfolgreich hinterlegt für",
  successfullySetServiceCallPermissions: "Serviceabrufeberechtigungen wurden erfolgreich hinterlegt für",
  bpInfoFor: "Geschäftspartner Information für:",
  contactPerson: "Kontaktperson",
  postalAddress: "Postanschrift",
  standardBillingAddress: "Standard Rechnungsadresse",
  bpTelephone: "Geschäftspartner Telefon",
  fax: "Fax",
  email: "Email",
  website: "Webseite",

  //UserServiceCallPermissions.vue
  serviceCallPermissions: "Serviceabrufe Berechtigungen und Zuweisungen",
  searchTitle: "Suche:",
  stagesTitle: "Stufen",
  serviceCallsTitle: "Serviceabrufe",
  serviceCallCreatedOn: "Serviceabruf erstellt am",
  serviceCallStartedOn: "Serviceabruf gestartet am",
  serviceCallMustEnd: "Muss abgeschlossen sein am",
  statusAbgeschlossen: "Abgeschlossen",
  statusOffen: "Offen",
  statusUnbekannt: "Unbekannt",
  statusAusstehend: "Ausstehend",

  noServiceCalls: "Keine Serviceabrufe vorhanden",
  noServiceTypes: "Keine Aktivitätstypen vorhanden",
  noBusinessPartners: "Keine Geschäftspartner vorhanden",
  serviceCalls: "Serviceabrufe",
  activityTypes: "Aktivitätstypen",
  searchBusinessPartners: "Wollen Sie nach Geschäftspartnern suchen?",
  searchDescriptionServiceCall: "Nach Serviceabruf suchen:",
  searchDescriptionCustomer: "Nach Geschäftspartner suchen:",
  businessPartner: "Geschäftspartner",
  userServiceCallPermissionSearchState: "Suche nach Status des Serviceabrufs",
  userServiceCallPermissionSearchSubject: "Suche nach Thema des Serviceabrufs",
  mirroringServiceCallSelected: "Nur ausgewählter Serviceabruf",
  mirroringServiceCallSelectedAll: "Alle von ausgewähltem Serviceabruf",
  mirroringCustomerSelected: "Nur ausgewählter Geschäftspartner",
  mirroringCustomer: "Geschäftspartner - Serviceabruf und Aktivitätsberechtigungen der/des Geschäftspartner/s auf ausgewählte Benutzer übertragen",
  mirroringServiceTypeSelected: "Nur ausgewählter Aktivitäten",
  mirroringAllSelectedCustomer: "Alle von ausgewähltem Geschäftspartner",
  mirroringServiceCall: "Serviceabrufberechtigungen auf ausgewählte Benutzer übertragen",
  mirroringServiceType: "Aktivitätstypenberechtigung auf ausgewählte Benutzer übertragen",
  userServiceCallPermissionSearchId: "Suche nach Servicabruf ID",
  userServiceCallPermissionSearchCustomerCode: "Suche nach Geschäftspartner Code",
  userServiceCallPermissionSearchName: "Suche nach Geschäftspartner Name",
  //StageProjectDialog
  noProjectsWithPermission: "Keine Projekte mit Berechtigung vorhanden",
  noServiceCallsWithPermission: "Keine Serviceabrufe mit Berechtigung vorhanden",

  //TimeReport
  exportBtn: "Export",
  exportBtnAll: "Export All",
  exportType: "Exportieren als",
  timeReport: "Zeitbericht",
  selectTimeReport: "Zeitbericht auswählen",
  monthly: "Monatlich",
  timePeriod: "Zeitraum",
  timeBlocks: "Zeitblöcke",
  workingTime: "Arbeitsstunden",
  timeIs: "Ist",
  timeDebit: "Soll",
  targetWorkTime: "Arbeitsstunden Soll",
  timeBalance: "Saldo",
  work: "Arbeit",
  timeIsSum: "Ist Summe",
  timeDebitSum: "Soll Summe",
  percent: "Prozent",
  autoModelTime: "Automodelzeiten",
  selectAllEmployees: "Alle Mitarbeiter auswählen",

  //infoDash.vue
  selectGroupsHint: "Bitte wählen Sie die Gruppen aus, welche diese Mitteilung sehen sollen",
  help: "Hilfe",
  holidays: "Jährliche Urlaubstage",
  logoNotUpdated: "Logo konnte nicht geändert werden!",
  absenceForDateAlreadyExists: "Abwesenheit für dieses Datum existiert bereits!",
  absenceAccountNotExists: "Ohne Urlaubskonto kann keine Abwesenheit angelegt werden!",
  holidayAccount: "Urlaubskonto",
  holidaysExpired: "Urlaubstage verfallen im nächsten Jahr",
  closeTimemodel: "Zeitmodell schließen",
  closeTimemodelDateWithClock: "Schließungsdatum (Um 00:00 Uhr)",
  closeTimemodelDate: "Schließungsdatum",
  createNewTimemodel: "Neues Zeitkonto erstellen",
  takeOldBalance: "Übernehme Zeitkonto Saldo aus vorherigen Zeitkonto",
  deleteTimemodelQuestion: "Möchten Sie wirklich das Zeitkonto zum angegebenen Datum schließen?",
  cancelDeleteTimemodelQuestion: "Möchten Sie wirklich das Zeitkontoschließung abbrechen?",
  todayWorktime: "Heutige Arbeitszeit",
  hrs: "Std.",
  worked: "gearbeitet",
  totalVacation: "Gesamturlaub",
  vacationTakenPrevMonth: "Urlaub genommen Vormonate",
  vacationTakenBeforeDate: "Urlaub genommen vor {0}",
  vacationTakenThisMonth: "Urlaub genommen aktueller Monat",
  vacationTakenInPeriod: "Urlaub genommen im Zeitraum",
  remainingVacation: "Resturlaub",
  open: "offen",
  planned: "verplant",
  taken: "genommen",
  unconfirmed: "unbestätigt",
  days: "Tage",
  showMonthlyHistorie: "Monatliche Historie öffnen",
  timeAccountIsClosing: "Zeitkontoschließung ist vorgemerkt!",
  timeModelNotSelected: "Zeitmodell wurde nicht ausgewählt",
  deleteTimemodelNowQuestion: "Möchten Sie wirklich das Zeitkonto löschen?",
  openBookingLinesWillBeDeleted: "Die letzter  Bookinglines werden gelöscht",
  employeeInformation: "Informationen anzeigen",
  timeAccountDisplay: "Zeitkonto Anzeigen",
  absenceNotPossibleBookingsAvailable: "Abwesenheitsantrag nicht möglich, da im Zeitraum Zeitbuchungen vorliegen!",
  absenceForUserNotPossibleBookingsAvailable: "Abwesenheitsantrag für {0} nicht möglich, da im Zeitraum Zeitbuchungen vorliegen!",
  absenceNotPossibleHolidayAvailable: "Abwesenheitsantrag nicht möglich, da im Zeitraum ein Feiertag vorliegen!",
  userNotFoundPasswordNotMatch: "Benutzer wurde nicht gefunden oder Password ist falsch!",
  userIsInactiveInSAP: " Zugriff ist verweigert! Benutzer ist Inaktiv in SAP",
  dateWithAbsenceBookingNotPossible: "Für diesen Tag ist eine Abwesenheit eingetragen. Zeitbuchung ist nicht möglich!",
  addDailyModel: "Tageszeitmodell hinzufügen",
  addWeeklyModel: "Wochenzeitmodell hinzufügen",
  addAutoWeekModel: "Automatisches Wochenmodell hinzufügen",
  saveDailyModel: "Tageszeitmodell speichern",
  saveWeeklyModel: "Wochenzeitmodell speichern",
  timeIsRequired: "Zeit darf nicht leer sein",
  newWeeklyModel: "Neuer Wochenzeitplan",
  newAutoWeeklyModel: "Neuer automatischer Wochenzeitplan",
  dailyModelNotSelected: "Tagesmodels wurde nicht ausgewählt!",
  weeklyModelName: "Wochenzeitmodell Bezeichnung",
  newDailyModel: "Neuer Tageszeitplan",
  timemodelName: "Zeitmodell Bezeichnung",
  debitWorkTime: "Sollarbeitszeit",
  remark: "Bemerkung",
  worktime: "Arbeitszeit",
  flexTime: "Gleitzeit",
  pauses: "Pausen",
  inHours: "in Stunden",
  weeklyWorkTime: "Wochenarbeitszeit",
  stages: "Stufen",
  noPermission: "Kein Berechtigung!",
  wrongOTPToken: "Falscher Token!",
  passwordSettings: "Passwort Einstellungen",
  enable: "Aktivieren",
  activateOTP: "Aktiviere Zwei-Faktor Authentifikation",
  nameIsRequired: "Name wird benötigt",
  maximumCharacterLengthReached: "Maximale Zeichenanzahl überschritten",
  editDailyModel: "Tageszeitplan bearbeiten",
  editWeeklyModel: "Wochenzeitplan bearbeiten",
  userHolidaysFrom: "Urlaubstage ab dem {0}",
  startHolidays: "Starturlaubstage vom {0}",
  holidaysUsed: "Urlaubstage genommen",
  holidaysPlanned: "Urlaubstage geplannt",
  holidaysBooked: "Urlaubstagen gebucht",
  lastYearUserHolidays: "Resturlaub vom letzten Jahr",
  restHolidays: "Resturlaub",
  oneChangeByTimeAccount: "Möchten Sie wirklich {0} ändern? Dadurch werden alle Buchungszeilen des Kontos korrigiert! Dies kann eine Weile dauern!",
  timeAccountStartValue: "den Startwert",
  timeAccountStartDate: "das Startdatum",
  timeAccountModell: "das Zeitmodell",
  twoChangesByTimeAccount: "Möchten Sie wirklich {0} und {1} ändern? Dadurch werden alle Buchungszeilen des Kontos korrigiert! Dies kann eine Weile dauern!",
  changeStartTimeAndStarDateAndWeekModel:
    "Möchten Sie wirklich Startwert, Startdatum und Zeitmodell ändern? Dadurch werden alle Buchungszeilen des Kontos korrigiert! Dies kann eine Weile dauern!",
  timeAccountNotUpdated: "Zeitkonto konnte nicht geändert werden!",
  pinLoginNotAllowed: "PIN Login nicht erlaubt!",
  noHolidayAccount: "Der Mitarbeiter besitzt kein Urlaubskonto!",
  noHolidayAccountForUser: "{0} besitzt kein Urlaubskonto!",

  enterYearlyHolidays: "Bitte jährliche Urlaubstage eintragen!",
  couldntAddOTPToUser: "OTP konnte beim Benutzer nicht aktiviert werden!",
  deactivate: "Deaktivieren",
  activate: "Aktivieren",
  twoFactorInfo1: "Warten Sie nicht mit der Aktivierung der Zwei Faktor Authentifizierung!",
  twoFactorInfo2: "Es ist nicht schwer zu aktivieren und hilft ihren Account vor unbefugten Zugriff zu schützen!",
  twoFactorInfo3: "Außerdem genießen Sie dann den Vorteil sich mittels eines 4-stelligen Pins einzuloggen. (+6-stelliger OTP Token)",
  twoFactorInfo4: "Sie müssen sich dadurch kein ewig langes Passwort mehr merken, sondern nur einen 4-stelligen PIN.",
  twoFactorInfo5: "Die 2 Faktor Authentifizierung ist optional aber sehr empfehlenswert, da Sie ihrem Account eine zusätzliche Schutzschicht hinzufügen.",
  twoFactorScanCodeInfo: "Scannen Sie den QR-Code mit Ihrem Handy und geben Sie den Code unten ein!",
  enableTwoFactor: "Aktiviere 2-Faktor Authentifizierung",
  twoFactor: "2-Faktor Authentifizierung",
  status: "Status",
  enterOTPCode: "Geben Sie das One Time Password aus der Authentifikator App ein!",
  enterCorrectStartTimeFormat: 'Falsches Format ("+/- HH:mm")',
  showPin: "PIN anzeigen!",
  showPinInfo: "Möchten Sie wirklich Ihren PIN anzeigen? Achten Sie darauf, dass nur Sie Einsicht auf den PIN haben!",
  hidePin: "PIN ausblenden!",
  emptyTimeAccountOnMonthStart: "Leere das Zeitkonto zum Monatsanfang (Aushilfsbasis z.B.)",
  cutWorkingTime: "Arbeitszeit kappen",
  cutStartTime: "Startzeit kappen",
  cutEndTime: "Endzeit kappen",
  deductBreakTimes: "gesetzliche Pausenzeiten automatisch abziehen",
  noActiveTimeAccount: "Kein aktives Zeitkonto. Bitte anlegen, damit Zeiten erfasst werden können.",
  timeModels: "Arbeitszeitmodelle",
  addAbsence: "Abwesenheit hinzufügen",
  absenceAsAdmin: "Abwesenheit kann als Admin nicht eingetragen werden!",
  removeVacation: "Urlaub entfernen",
  removeAbsence: "Abwesenheit entfernen",
  addReasonAbsence: "Abwesenheitsgrund hinzufügen",
  removeAbsenceQuestion: "Möchten Sie die Abwesenheit löschen?",
  addAbsenceReasons: "Abwesenheitsgründe hinzufügen",
  designation: "Bezeichnung",
  red: "Rot",
  purple: "Lila",
  blue: "Blau",
  cyan: "Cyan",
  indigo: "Indigo",
  violet: "Violett",
  orange: "Orange",
  deepOrange: "Dunkelorange",
  brown: "Braun",
  lime: "Hellgrün",
  amber: "Bernsteinfarbe",
  blueGrey: "Blaugrau",
  teal: "Türkis",
  deepPurple: "Dunkelviolett",
  checkInput: "Bitte prüfen Sie ihre Eingabe!",
  pleaseSelectIcon: "Bitte wählen Sie ein Icon aus!",
  pleaseSelectColorCode: "Bitte wählen Sie einen Farbcode aus!",
  pleaseSelectName: "Bitte geben Sie einen Namen ein!",
  chooseLocation: "Standort auswählen",
  statusInHouse: "Im Haus",
  statusOut: "Außer Haus",
  statusVacation: "Im Urlaub",
  statusHomeOffice: "Im Home Office",
  statusIll: "Krank",
  noDepartment: "Keine zugewiesene Abteilung",
  statusUnknown: "Unbekannt",
  addAttachment: "Anhang hinzufügen",

  // Setup
  pleaseRestartServiceLayer: "Bitte Service Layer neustarten und danach diesen Dialog bestätigen. Daraufhin wird der COBI.time Server neugestartet!",
  notInSetupMode: "Server befindet sich nicht im Setup Modus!",
  serviceNotReachablePleaseRefresh: "Verbindung mit COBI.time Dienst konnte nicht hergestellt werden! Bitte Seite aktualisieren!",
  installSuccessfull: "COBI.time wurde erfolgreich installiert/aktualisiert! Webseite wird neu geladen!",
  installSuccessfullPleaseRefresh: "COBI.time wurde erfolgreich installiert/aktualisiert! Bitte die Seite manuell aktualisieren!",
  serviceLayerRestartedSuccessfully: "Service Layer erfolgreich neugestartet! Webseite wird aktualisiert!",
  changelog: "Introduction / Changelog",
  tables: "Tabellen",
  execute: "AUSFÜHREN",
  tableFields: "Felder",
  tableData: "Daten",
  setupUpdate: "Setup / Update",
  publicHolidayManagement: "Feiertagsverwaltung",
  faceNotFound: "Gesicht wurde nicht erkannt!",
  faceRecognitionDisabled: "Face Recognition ist deaktiviert oder nicht konfiguriert!",
  tryFaceLogin: "Versuche Login mit Gesichtsdaten. Bitte warten...",
  deleteProfilePicture: "Profilbild entfernen",
  deleteProfilePictureQuestion: "Möchten Sie wirklich das Profilbild entfernen?",
  showFaceHelpText: "Bitte Gesicht in der Mitte platzieren und nicht bewegen..",
  reportType: "Reporttyp",

  // Useradministration.vue
  representative: "Stellvertreter",
  manager: "Manager",

  // StageProjectDialog
  costCenter: "Kostenstelle",
  chooseCostCenter: "Kostenstelle wählen",
  // PopUpEditStages.vue
  editActivityTypes: "Aktivitätstypen anpassen",
  // EventLog.vue
  eventLogs: "Ereignis Logs",
  filterColumns: "Spalten wählen",
  filter: "Filter",
  columnSelection: "Gewählte Spalten",
  breadcrumbsFilter: "Ausgewählte Filter",
  logfileExport: "Logdatei exportieren",
  noEventLogEntries: "Es liegen keine Einträge für das angegebene Datum vor",
  pageSize: "Einträge pro Seite",
  dataRefreshed: "Daten erfolgreich neu geladen",
  timeCorrectionBy: "Zeitkorrektur von",
  wasAssignedNewTimeAccount: "wurde ein neues Zeitkonto zugewiesen",
  activeFrom: "Aktiv ab",
  dataRefreshConfirm:
    "Möchten Sie die Daten wirklich neu laden? Dies kann einige Zeit in Anspruch nehmen! Sie können die Seite währenddessen weiterhin verwenden. Um die Ladezeit zu verringen, können Sie den Zeitraum verkleinern.",
  dateRangeError: "Das Enddatum muss nach dem Startdatum liegen!",
  cancelled: "Storniert",
  removeBreadCrumb: "Filter entfernen",
  dateFrom: "Von",
  dateUntil: "Bis",

  //EventLog Transaction Types
  EditUserRights: "Benutzerrechte bearbeitet",
  WorkStatus: "Arbeitsstatus",
  TimeCorrection: "Zeitkorrektur",
  by: "von",

  // EventLog Headers
  U_severity: "Level",
  U_name: "Benutzername",
  U_type: "Transaktionstyp",
  U_date: "Datum",
  U_time: "Uhrzeit",
  U_status: "Status",
  WorkStart: "Arbeit begonnen",
  WorkEnd: "Arbeit beendet",
  PauseStart: "Pause begonnen",
  PauseEnd: "Pause beendet",
  ProjectStart: "Projekt begonnen",
  ProjectEnd: "Projekt beendet",
  ProjectPauseStart: "Projekt Pause begonnen",
  ProjectPauseEnd: "Projekt Pause beendet",
  details: "Details",
  AbsenceRequest: "Abwesenheitsantrag",

  // EventLog UserEditRights
  revoked: "entzogen",
  granted: "erteilt",
  admin: "Admin",
  user: "Benutzer",
  projectUser: "Projektbuchung",
  manualTimeKeeping: "Manuelle Zeiterfassung",
  employeeManager: "Benutzerverwaltung",
  presenceList: "Anwesenheitsliste",
  presentList: "Anwesenheitsliste",
  presenceListAll: "Answesenheitsliste (alle)",
  timeCorrection: "Zeitkorrekturen",
  canSeeEmployeeTimes: "Kann Zeitbuchungen der Mitarbeiter sehen",
  projectAndBreakTimeManipulation: "Projekt- und Pausenzeiten bearbeiten",
  canChangeBusinessTripTime: "Kann Dienstreisen buchungen und bearbeiten",
  userRight: "Benutzerrecht",

  // Dynamic List
  elementsSelected: "Elemente ausgewählt",
  elementSelected: "Element ausgewählt",

  // Genral Reporting
  refresh: "Aktualisieren",
  generalReporting: "Berichtswesen",
  workTimeReport: "Arbeitszeitbericht",
  vacationReport: "Abwesenheitsbericht",
  teams: "Teams",
  U_project: "Projekt",
  U_businessTrip: "Dienstreise",
  // not sure if we need this
  U_employeeId: "Personalnr.",
  U_extID: "Ext. Personalnr.",

  detailedReport: "Detailbericht",
  dailyReport: "Tagesbericht",
  weeklyReport: "Wochenbericht",
  monthlyReport: "Monatsbericht",
  yearlyReport: "Jahresbericht",
  evaluationReport: "Auswertungsbericht",
  greaterThan: "Größer als",
  lessThan: "Kleiner als",

  U_workTime: "Arbeitszeit",
  U_breakTime: "Pausenzeit",
  U_businessTripTime: "Dienstreisezeit",
  U_projectTime: "Projektzeit",
  U_totalTime: "Istzeit",
  U_absenceTime: "Abwesenheitszeit",
  U_paidAbsenceTime: "Bezahlt Abwesenheit",
  U_unpaidAbsenceTime: "Unbezahlt Abwesenheit",
  U_requiredTime: "Sollzeit",
  calendarWeek: "Kalenderwoche",
  U_difference: "Differenz",
  U_ratio: "Prozent",
  U_coming: "Kommen",
  U_leaving: "Gehen",
  U_sumIs: "Summe (ist)",
  U_sumWas: "Summe (war)",
  U_debit: "Saldo",
  timeAccountCorr: "Saldo Korrektur",

  noDataAvailable: "Keine Daten verfügbar",
  noDataAvailableForSelectedParameters: "Für die ausgewählten Parameter sind keine Daten verfügbar.",
  resetFilter: "Filter zurücksetzen",

  dailySicknessRate: "Krankheitsquote",
  sickEmployees: "Kranke MA",
  totalEmployees: "Gesamt MA",
  sicknessRate: "Krankheitsquote",
  department: "Abteilung",
  team: "Team",
  date: "Datum",

  // Months
  month_Jan: "Januar",
  month_Feb: "Februar",
  month_Mar: "März",
  month_Apr: "April",
  month_May: "Mai",
  month_Jun: "Juni",
  month_Jul: "Juli",
  month_Aug: "August",
  month_Sep: "September",
  month_Oct: "Oktober",
  month_Nov: "November",
  month_Dec: "Dezember",

  // WorkTimeSummary
  workTimeSummary: "Arbeitszeitübersicht",
  workTimeWas: "Übertrag aus vorherigem Zeitraum",
  workTimeIs: "Neuer Zeitkontensaldo",
  U_department: "Abteilung",
  U_weekday: "Wochentag",
  U_average: "Durchschnitt",

  // AbsenceReport
  vacationReportNotSameYear: "Abwesenheitsbericht kann nicht jahresübergreifend erstellt werden",
  U_reason: "Grund",
  U_factor: "Faktor",
  U_countAsWorkingTime: "Bezahlt/Unbezahlt",
  paid: "Bezahlt",
  unpaid: "Unbezahlt",
  U_openVacation: "Resturlaub",
  U_usedVacation: "gen. Urlaub",
  U_totalVacation: "Urlaubsanspruch",
  U_comment: "Kommentar",

  U_memberCount: "Mitgliederanzahl",

  perUserReport: "Benutzerbericht",
  perDepartmentReport: "Abteilungsbericht",
  usedVacationForSelectedPeriod: "Gen Urlaub(def. Zeitraum)",

  fetchingData: "Daten werden geladen",
  processingData: "Daten werden verarbeitet",

  // Misc
  selectAll: "Alle auswählen",

  // User Report
  calenderWeek: "KW",
  weekDay: "Tag",
  timeTotal: "Arbeitszeit",
  presentTime: "Anwesenheitswert",
  absenceTime: "Abwesenheitszeit",
  businessTripTime: "Dienstreisezeit",
  timeRequired: "Sollzeit",
  comeAndGoTimes: "Kommen + Gehen",
  breakTimeTotal: "ges. Pausezeit",
  breaks: "Pausen",
  activitiesTotalTime: "Akt.-Z.",
  activities: "Activitäten",
  dayBalance: "Differenz",
  timeBalanceAbb: "Saldo",
  timeAccountCorrections: "Saldo Korr.",
  publicHolidaysAbb: "Feiertag",
  overallPeriod: "Gesamtzeitraum:",

  calenderWeekExplain: "Kalender Woche",
  weekDayExplain: "Tag",
  timeTotalExplain: "Arbeitszeit",
  presentTimeExplain: "Anwesenheitswert",
  absenceTimeExplain: "Abwesenheitszeit",
  businessTripTimeExplain: "Dienstreisezeit",
  timeRequiredExplain: "Sollzeit",
  comeAndGoTimesExplain: "Kommen + Gehen",
  breakTimeTotalExplain: "Gesamt Pausezeit",
  breaksExplain: "Pausen Zeiten",
  activitiesTotalTimeExplain: "Aktivitäten Zeiten",
  activitiesExplain: "Aktivitäten",
  dayBalanceExplain: "Differenz",
  timeBalanceAbbExplain: "Saldo",
  timeAccountCorrectionsExplain: "Saldo Korrektur",
  holidayExplain: "Urlaub",
  illnessExplain: "Krankheit",
  publicHolidaysAbbExplain: "Feiertag",
  otherAbsencesExplain: "Sonstige Abwesenheiten",
  dateExplain: "Datum",
  transferFromWorkTime: "Übertrag aus Arbeitszeit",
  newBalance: "Neuer Saldo",
  previousMonthBalance: "Saldo Vormonat",
  newBalance: "Neuer Saldo",
  descriptions: "Beschreibung",
  timeValue: "Zeitwert",
  total: "Gesamt",
  vacationSummary: "Urlaubsübersicht",
  absencesSummary: "Abwesenheitsübersicht",

  pinUnlock: "Pin Freischaltung",
  passwordForPinUnlockIncorrect: "Password für Pin Freischaltung ist falsch!",
  timeoutSeconds: "Sekunden bis auslogen",
  presentEmployeesTooltip: "Anwesende Mitarbeiter (Inkl. in Pause) <br> Im Haus: {0} <br> Im Home Office: {1} <br> Außer Haus: {2}",
  absenceEmployeesTooltip: "Abwesende Mitarbeiter",

  // Statistics

  statistics: "Statistik",
  kpiTabHealth: "Gesundheit",
  kpiTabHeadcount: "Personalbestand",
  kpiTabStructure: "Struktur",
  kpiTabContracts: "Verträge",
  kpiTabDataQuality: "Datenqualität",
  dailySicknessRate: "Krankheitsquote",
  kpiSicknessTrendHint: "Verlauf der Krankheitsquote im ausgewählten Zeitraum",
  kpiFilterDateFrom: "Datum von",
  kpiFilterDateTo: "Datum bis",
  kpiFilterScopeLabel: "Geltungsbereich",
  kpiFilterOrgUnitLabel: "Organisationseinheit",
  kpiScopeCompany: "Gesamtunternehmen",
  kpiScopeDepartment: "Abteilung",
  kpiScopeEmployee: "Mitarbeiter",
  all: "Alle",
  kpiSelectDepartment: "Abteilung auswählen",
  kpiSelectEmployee: "Mitarbeiter auswählen",
  remaining: "Rest",
  kpiPeriodType: "Auswertungsmodus",
  kpiPeriodMonthly: "Monatlich",
  kpiPeriodYearly: "Jährlich",
  kpiPeriodRange: "Zeitraum",
  kpiPeriodMonth: "Monat",
  kpiPeriodYear: "Jahr",
  monthJanuary: "Januar",
  monthFebruary: "Februar",
  monthMarch: "März",
  monthApril: "April",
  monthMay: "Mai",
  monthJune: "Juni",
  monthJuly: "Juli",
  monthAugust: "August",
  monthSeptember: "September",
  monthOctober: "Oktober",
  monthNovember: "November",
  monthDecember: "Dezember",

  // ____________________________________________________

  connectWasSuccessful: "Mit SAP verbunden",
  connectionHasFailed: "Verbindung ist fehlgeschlagen",
  connectingToSAP: "Verbindung zu SAP wird hergestellt..."
};
